/* eslint-disable eqeqeq */
import {action, observable, computed, override, makeObservable} from 'mobx';
import {PackagesCollection} from './PackagesCollection';
import {Field} from '../../Common/stores/Field';
import * as fieldTypes from '../../../../constants/FieldTypes';

export class PackagesField extends Field {
    @observable status;
    @observable marked;
    @observable description;

    origStatus;
    sum;
    packid;
    unlocked;
    changed;
    license;

    constructor(field, parentField) {
        super(field, parentField);
        makeObservable(this);
        this.sum = field.sum;
        this.marked = field.marked;
        this.status = field.status;
        this.origStatus = field.status;
        this.packid = field.packid;
        this.unlocked = field.unlocked;
        this.description = '';
        this.license = field.license;
        this.changed = false;
        this.collection = new PackagesCollection(parentField.collection);
    }

    setCollection(field) {
        field.fields && this.collection.insertFields(this, field.fields);
    }

    @action showHide(isShow) {
        this.changed = true;
        if (this.origStatus == isShow) {
            this.changed = false;
        }

        if (this.type === fieldTypes.TAB) {
            this.collection.fields.forEach(field => {
                if (field.status != isShow) {
                    field.showHide(isShow);
                }
            });
        } else {
            if (this.status != isShow) {
                this.status = isShow;
                this.parentField.changed = true;
                if (!!isShow) {
                    ++this.parentField.marked;
                } else {
                    --this.parentField.marked;
                }
            }
        }
    }

    setMoved(value) {
        this.moved = value;
    }

    @action setDescription(descriptionArr) {
        const description = descriptionArr && descriptionArr[0];
        if (description) {
            this.description = description.help;
        }
    }

    @override get hidden() {
        return this.status == false;
    }

    @computed get isLocked() {
        return this.license == 0;
    }
}
/* eslint-enable eqeqeq */
